<template>
  <div id="app">
    <v-form class="container p-5" ref="form" v-model="valid" lazy-validation>
      <div>
        <h5 style="margin-right: 750px">Select PlanCode And Region</h5>
        <v-row>
          <v-col md="3">
            <v-select
              :items="category"
              required
              label="Category"
              v-model="form.identity.category"
              v-on:change="categoryPlan(form.identity.category)"
            ></v-select>
          </v-col>
          <v-col md="3">
            <v-select
              :items="region"
              required
              label="Select a Region"
              v-model="form.identity.region"
              v-on:change="Plancode(form.identity.region)"
            ></v-select>
          </v-col>
          <v-col md="3">
            <v-select
              :items="plancodes"
              required
              label="planCode"
              v-model="form.identity.planCode"
              v-on:change="
                PlanName(form.identity.region, form.identity.planCode)
              "
            ></v-select>
          </v-col>
          <v-col md="3">
            <v-text-field
              v-model="form.planName"
              label="planName"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <h5 style="margin-right: 855px; margin-top: 30px">Select Channels</h5>
      <div class="container" style="margin-top: 30px">
        <DualListBox
          :source="source"
          :destination="destination"
          @onChangeList="onChangeList"
        />
      </div>
      <v-btn
        class="primary mr-4"
        style="margin-left: 900px"
        @click="handleSubmit"
        >Submit</v-btn
      >
    </v-form>
  </div>
</template>
<script>
import axios from "axios";
import DualListBox from "dual-listbox-vue";
import "dual-listbox-vue/dist/dual-listbox.css";
import { channelmapping } from "@/services/planchannelmapping";
import { extractError } from "../../utils/error";
export default {
  name: "App",
  components: {
    DualListBox,
  },
  data: function () {
    return {
      form: {
        identity: {
          category: "",
          region: "",
          planCode: "",
        },
        planName: "",
        valid: true,
        channelMasters: [],
      },
      source: [],
      destination: [],
      category: ["BST", "BRI", "BQ"],
      region: [
        "PRCKOLHAPUR",
        "PRCKOLHAPURDAS4",
        "PRCSATARADAS3",
        "PRCSATARADAS4",
      ],
      plancodes: [],
      planName: "",
    };
  },

  methods: {
    onChangeList: function ({ source, destination }) {
      this.source = source;
      this.destination = destination;
      this.form.channelMasters = this.destination.map(function (x) {
        return { id: x.id };
      });
    },
    categoryPlan(selectCatogery) {
      let planCodes = [];
      this.form.identity.planCode = "";
      this.form.planName = "";
      let selectedRegion = this.form.identity.region;
      if (selectCatogery && selectedRegion) {
        axios
          .get(
            `https://test.bripl.in/v1/api/customer/plan/all-packages/mapping?region=${selectedRegion}&category=${selectCatogery}`
          )
          .then(
            (response) => (
              (this.totalJsonData = response.data),
              this.totalJsonData.map(function (x) {
                if (x.identity.region == selectedRegion) {
                  planCodes.push(x.identity.planCode);
                }
              })
            )
          )
          .catch((err) => {
            this.errored = true;
          });
        this.plancodes = planCodes;
      }
    },
    Plancode(selectedRegion) {
      // debugger

      let planCodes = [];
      this.form.identity.planCode = "";
      this.form.planName = "";
      let selectCatogery = this.form.identity.category;
      if (selectCatogery && selectedRegion) {
        axios
          .get(
            `https://test.bripl.in/v1/api/customer/plan/all-packages/mapping?region=${selectedRegion}&category=${selectCatogery}`
          )
          .then(
            (response) => (
              (this.totalJsonData = response.data),
              this.totalJsonData.map(function (x) {
                if (x.identity.region == selectedRegion) {
                  planCodes.push(x.identity.planCode);
                }
              })
            )
          )
          .catch((err) => {
            this.errored = true;
          });
        this.plancodes = planCodes;
      }
    },
    PlanName: function (selectedRegion, planCode) {
      let resultArray = [];

      this.totalJsonData.map(function (x) {
        if (
          x.identity.region == selectedRegion &&
          x.identity.planCode == planCode
        ) {
          resultArray = [x.planName];
          //return x.planName;
        }
      });
      this.form.planName = resultArray[0];
    },

    async getPlanData() {
      axios
        .get("https://test.bripl.in/v1/api/customer/plan/all-package")
        .then((response) => {
          this.totalJsonData = response.data.content;
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },

    async getChannelData() {
      axios
        .get("https://test.bripl.in/v1/api/channel/all-channels")
        .then(
          (response) =>
            (this.source = response.data.content.map(function (x) {
              return { id: x.id, label: x.channelName };
            }))
        )
        .catch((err) => {
          this.errored = true;
        })
        .finally(() => (this.loading = false));
      // .catch(error => this.log({ err: error.message }));
    },

    async validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    async handleSubmit() {
      //  try{
      //  const hasError = this.validate();
      // if (hasError) {
      //   this.$toasted.error(hasError, {
      //     duration: 2000
      //   });
      //   return;
      // }
      const { form, ...payload } = this.form;
      const result = await channelmapping(payload);

      //const { response: { userID: userId }  } = result;
      payload[form] = true;
      this.$router.push({
        name: "Planchannelmapping",
        params: {},
      });
      this.$toasted.success("Successfully created", {
        duration: 2000,
      });
    },
    catch(err) {
      const message = extractError(err);
      this.$showError(message);
    },
  },
  // },
  async mounted() {
    this.getChannelData();
    await this.getPlanData();
  },
};
</script>
<style>
.list-box-wrapper .list-box-item .bulk-action .select-all {
  background-color: #59065d;
}
.btn-action {
  background-color: #59065d;
  border-color: #59065d;
}
.list-box-wrapper .list-box-item .bulk-action .deselect-all {
  background-color: #c7c7ca;
  color: black;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
</style>
